import type { JSONContent } from '@tiptap/react';

export class JsonSchemaCleaner {
  cleaned: boolean = false;
  cleanedNodes: any[] = [];

  wasCleaned() {
    return this.cleaned;
  }

  getCleaned() {
    return JSON.stringify(this.cleanedNodes);
  }

  clean(json: JSONContent) {
    return this.cleanInvalidNodes(json, 'doc') ?? {};
  }

  cleanInvalidNodes(jsonContent: JSONContent, contextType: string) {
    if (!this.isValidNode(jsonContent, contextType)) {
      this.cleaned = true;
      this.cleanedNodes.push(jsonContent);
      return null;
    }

    const cleanedContent = { ...jsonContent };

    if (jsonContent.content && Array.isArray(jsonContent.content)) {
      (cleanedContent.content as any) = jsonContent.content.reduce(
        (acc, node) => {
          const cleanedNode = this.cleanInvalidNodes(
            node,
            jsonContent.type ?? contextType
          );
          if (cleanedNode) {
            acc.push(cleanedNode);
          }
          return acc;
        },
        []
      );
    }

    return cleanedContent;
  }

  isValidNode(node, contextType) {
    if (
      typeof node !== 'object' ||
      node === null ||
      typeof node.type !== 'string'
    ) {
      return false;
    }

    if (node.content && !Array.isArray(node.content)) {
      return false;
    }

    // No empty text
    if (node.type === 'text' && node.text === '') {
      return false;
    }

    if (contextType === 'doc') {
      // Remove invalid doc level items
      const invalidDocLevelNodes = ['hardBreak', 'text'];
      if (invalidDocLevelNodes.includes(node.type)) {
        return false;
      }
    }

    if (contextType === 'bulletList' || contextType === 'orderedList') {
      // Remove any node that isnt a list item
      if (node.type !== 'listItem') {
        return false;
      }
    }

    return true;
  }
}
